import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const evaluationBenchmarkingComponent: ComponentDef = {
  id: 'evaluation-benchmarking',
  name: 'Evaluation & Benchmarking',
  description: 'Run model evaluations on standard benchmarks and aggregate accuracy metrics.',
  category: 'optimization',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    {
      name: 'variant',
      label: 'Variant',
      type: 'select',
      default: 'serving_metrics',
      options: [
        { label: 'Serving Metrics', value: 'serving_metrics' },
        { label: 'Latency Breakdown', value: 'latency_breakdown' },
        { label: 'Benchmarking Tools', value: 'benchmark_tools' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const variant = String(params.variant);

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);

    if (variant === 'latency_breakdown') {
      // Latency breakdown: show where time is spent
      g.linear('model', 'x', [d_model, d_model]);
      g.scale('tokenize_time', 'model', 'Tokenize');
      g.scale('prefill_time', 'tokenize_time', 'Prefill');
      g.scale('decode_time', 'prefill_time', 'Decode/token');
      g.scale('sampling_time', 'decode_time', 'Sampling');
      g.scale('detokenize_time', 'sampling_time', 'Detokenize');
      g.concat('breakdown', ['tokenize_time', 'prefill_time', 'decode_time', 'sampling_time', 'detokenize_time'], [5]);
      g.metric('total_latency', 'breakdown', 'Total Latency');
      g.output('out', 'total_latency');
    } else if (variant === 'benchmark_tools') {
      // Benchmarking tools: lm-eval, HELM, BIG-bench comparison
      g.linear('model', 'x', [d_model, d_model]);
      g.scale('lm_eval', 'model', 'lm-eval-harness');
      g.scale('helm', 'model', 'HELM');
      g.scale('big_bench', 'model', 'BIG-bench');
      g.concat('tool_results', ['lm_eval', 'helm', 'big_bench'], [3]);
      g.metric('coverage', 'tool_results', 'Task Coverage');
      g.metric('reproducibility', 'coverage', 'Reproducibility');
      g.output('out', 'reproducibility');
    } else {
      // Serving metrics (default): ARC, HellaSwag, MMLU aggregate
      g.linear('model', 'x', [d_model, d_model]);
      g.scale('arc', 'model', 'ARC');
      g.scale('hellaswag', 'model', 'HellaSwag');
      g.scale('mmlu', 'model', 'MMLU');
      g.concat('scores', ['arc', 'hellaswag', 'mmlu'], [3]);
      g.metric('avg', 'scores', 'Average');
      g.output('out', 'avg');
    }

    return g.build();
  }
};
